module.exports = __webpack_public_path__ + "static/logo-8b18114cc8c16db215f960b82bed7bc1.png";